import { useContext } from "react";
import TranslationContext, { TranslationsContextType } from "./translations-context";

export default function useTranslationList(): TranslationsContextType {
    return useContext(TranslationContext)
}